import { itx } from "../../../src/translationItx/itx";
import { useLayoutEffect, useRef, useState } from "react";

/** Measures SVG text so long item names remain inside the hover button. */
export function C1_EloAddBadge({ name }: { name: string }) {
  const label = itx("c1.ui.value1_hinzufugen", "{{value1}} hinzufügen", { "{{value1}}": String(name) });
  const textRef = useRef<SVGTextElement>(null);
  const [textWidth, setTextWidth] = useState(label.length * 2.5);
  useLayoutEffect(() => {
    const width = textRef.current?.getComputedTextLength();
    if (width) setTextWidth(width);
  }, [label]);
  return <>
    <rect x={-1} y={-3.5} width={textWidth + 8} height={7} rx={3.5} />
    <text ref={textRef} x={3} y={0} textAnchor="start" dominantBaseline="central">{label}</text>
  </>;
}
